import { render, staticRenderFns } from "./userDistribution.vue?vue&type=template&id=64559fe7&scoped=true&"
import script from "./userDistribution.vue?vue&type=script&lang=js&"
export * from "./userDistribution.vue?vue&type=script&lang=js&"
import style0 from "./userDistribution.vue?vue&type=style&index=0&id=64559fe7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64559fe7",
  null
  
)

export default component.exports